// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__YuZWp","avatar":"NavBar_avatar__u3tO2","top":"NavBar_top__e2kGD","bottom":"NavBar_bottom__NB9Qe"};